module.exports = __webpack_public_path__ + "static/media/suzhouguangji_logo.78555eee.png";